import React from 'react';
import type { SVGDefaultProps } from './types';
import { colors } from '@/styles';

export const LFSent = ({ size = 14, title = 'Sent', fill = colors.boulder }: SVGDefaultProps) => {
  const height = Number(size) * 2.85;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" height={height} viewBox="0 0 11.74 11.07">
      {Boolean(title) && <title>{title}</title>}
      <path fill={fill} d="M6.21 0L5.09 1.12l3.63 3.62H0v1.58h8.71L5.09 10l1.12 1.12 5.53-5.55z" />
    </svg>
  );
};
